export const PHONE_MASK_LENGTH = 16
